import React, { useCallback, useEffect, useState, useRef } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import AudioFilesToProcess from "./TranscriptionComponents/AudioFilesToProcess";
import TranscriptionProcess from "./TranscriptionComponents/TranscriptionProcess";
import TranscriptionProcessLogs from "./TranscriptionComponents/TranscriptionProcessLogs";
import TranscriptionFilewiseStatusLogs from "./TranscriptionComponents/TranscriptionFilewiseStatusLogs";
import { TRANSCRIPT_URL, PROJECT_URL } from "../../imports";
import axios from "axios";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";


function Transcription() {
    const [startProcess, setStartProcess] = useState(false);
    const [backgroundProcess, setBackgroundProcess] = useState(false);
    
    // ✅ Separate state for Audio Files tab (unprocessed files)
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    
    // ✅ Separate state for Transcription Process tab (in-progress files)
    const [inProgressFiles, setInProgressFiles] = useState([]);
    
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [processOption, setProcessOption] = useState("normal");
    const [serverOFF, setServerOFF] = useState(false);
    
    // Audio Files tab pagination
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    
    // All Files Status tab pagination
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});

    const [activeTab, setActiveTab] = useState(0);
    
    const [transcriptionSettings, setTranscriptionSettings] = useState({
        api_key: "",
        service: "openai",
        keep_original_lang: 0,
        enable_pre_process: 1,
        pii_masking: 0,
        pii_entities_list: []
    });
    
    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    // ✅ Polling interval ref
    const pollingIntervalRef = useRef(null);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, []);

    // ✅ Fetch in-progress transcriptions
    // const fetchInProgressTranscriptions = useCallback(async () => {
    //     try {
    //         const projectCode = sessionStorage.getItem("projectCode");
    //         if (!projectCode) return;

    //         const response = await axios.get(
    //             `${TRANSCRIPT_URL}/transcribe/in-progress/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data && response.data.data) {
    //             setInProgressFiles(response.data.data);
    //             console.log(`✅ Loaded ${response.data.data.length} in-progress transcriptions`);
    //         }
    //     } catch (error) {
    //         console.log("No in-progress transcriptions:", error.message);
    //         setInProgressFiles([]);
    //     }
    // }, []);

    // ✅ Stop polling
    const stopPolling = useCallback(() => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
            console.log("⏹️ Stopped polling");
        }
    }, []);

    const fetchInProgressTranscriptions = useCallback(async () => {
        try {
            const projectCode = sessionStorage.getItem("projectCode");
            if (!projectCode) return;

            const response = await axios.get(
                `${TRANSCRIPT_URL}/transcribe/in-progress/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            if (response.data && response.data.data) {
                // ✅ Filter to only show files that are truly in progress
                const activeFiles = response.data.data.filter(file => 
                    file.status === "Inprogress" || 
                    file.status === "submitted" || 
                    file.status === "Processing"
                );
                
                setInProgressFiles(activeFiles);
                console.log(`✅ Loaded ${activeFiles.length} in-progress transcriptions`);
                
                // ✅ If no files in progress, stop polling
                if (activeFiles.length === 0) {
                    stopPolling();
                }
            }
        } catch (error) {
            console.log("No in-progress transcriptions:", error.message);
            setInProgressFiles([]);
        }
    }, [stopPolling]);

    // ✅ Fetch all files (for Audio Files tab - excluding in-progress)
    const fetchAllFiles = useCallback(async (batch_no = null) => {
        try {
            setLoader(true);
            const projectCode = sessionStorage.getItem("projectCode");
            
            const response = await axios.get(
                `${TRANSCRIPT_URL}/transcribe/Transcription/getfilelist/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    params: {
                        batch: batch_no || sessionStorage.getItem("batch") || null,
                    },
                }
            );

             // Fetch completed files status
            const statusResponse = await axios.get(
                `${TRANSCRIPT_URL}/transcribe/Transcription/filewisestatusrpt/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            // if (response.data && response.data.data) {
            //     // ✅ Filter out files that are currently processing
            //     const allFiles = response.data.data;
            //     console.log("Full API response:", JSON.stringify(allFiles, null, 2));

            //     const completedFileCodes = statusResponse.data.data.filter(f => f.status === "Success" || f.status === "success").map(f => f.file_code);

            //     // const availableFiles = allFiles.filter(file => 
            //     //     file.status !== "Inprogress" && 
            //     //     file.status !== "submitted" &&
            //     //     file.status !== "Processing" &&
            //     //     file.status !== "Success" &&
            //     //     file.status !== "success" &&
            //     //     !file.response
            //     // );
            //      // Filter out files that are processing, completed, or have a response
            //     // const availableFiles = allFiles.filter(file => 
            //     //     file.status !== "Inprogress" && 
            //     //     file.status !== "submitted" &&
            //     //     file.status !== "Processing" &&
            //     //     file.status !== "Success" &&
            //     //     file.status !== "success" &&
            //     //     !completedFileCodes.includes(file.file_code)
            //     // );
            //     // Filter out text/json/csv files and processing/completed files
            //     // const availableFiles = allFiles.filter(file => {
            //     //     const fileName = file.file_name || file.name || "";
            //     //     const isTextFile = fileName.endsWith('.txt') || fileName.endsWith('.json') || fileName.endsWith('.csv');
            //     //     const isProcessing = file.status === "Inprogress" || file.status === "submitted" || file.status === "Processing" || file.status === "Success" || file.status === "success";
            //     //     const isCompleted = completedFileCodes.includes(file.file_code);
                    
            //     //     return !isTextFile && !isProcessing && !isCompleted;
            //     // });
            //     const availableFiles = allFiles.filter(file => {
            //         const fileName = file.file_name || file.name || "";
            //         const isTextFile = fileName.endsWith('.txt') || fileName.endsWith('.json') || fileName.endsWith('.csv');
                    
            //         return !isTextFile;
            //     });
            //     setFetchedFilesData(availableFiles);
            //     console.log(`✅ Loaded ${availableFiles.length} available files`);
            // }
            if (response.data && response.data.data) {
                const allFiles = response.data.data;
                
                // Fetch completed files status
                const statusResponse = await axios.get(
                    `${TRANSCRIPT_URL}/transcribe/Transcription/filewisestatusrpt/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                
                // Create a map of file_code to status
                const statusMap = {};
                if (statusResponse.data && statusResponse.data.data) {
                    statusResponse.data.data.forEach(statusFile => {
                        statusMap[statusFile.file_code] = statusFile.status;
                    });
                }
                
                // Filter and merge status
                const availableFiles = allFiles
                    .filter(file => {
                        const fileName = file.file_name || file.name || "";
                        return !fileName.endsWith('.txt') && !fileName.endsWith('.json') && !fileName.endsWith('.csv');
                    })
                    .map(file => ({
                        ...file,
                        status: statusMap[file.file_code] || file.status || "uploaded"
                    }));
                
                setFetchedFilesData(availableFiles);
                console.log(`✅ Loaded ${availableFiles.length} available files`);
            }
        } catch (error) {
            const errorMessage = handleApiError(error);
            setMsg(errorMessage);
            setIsSuccess(false);
            openPopup();
        } finally {
            setTimeout(() => setLoader(false), 100);
        }
    }, [openPopup]);

    // ✅ Start polling for in-progress files (every 5 seconds)
    const startPolling = useCallback(() => {
        if (pollingIntervalRef.current) return; // Already polling

        pollingIntervalRef.current = setInterval(() => {
            fetchInProgressTranscriptions();
        }, 5000);

        console.log("🔄 Started polling for in-progress transcriptions");
    }, [fetchInProgressTranscriptions]);

    

    // ✅ Improved: Load in-progress files on mount and set up polling
    useEffect(() => {
        const initializeData = async () => {
            await Promise.all([
                fetchAllFiles(),
                fetchInProgressTranscriptions(),
            ]);

            // Check server status
            try {
                const response = await axios.get(
                    `${TRANSCRIPT_URL}/transcribe/instancemonitor`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        params: { server_instance: "GPU" },
                    }
                );
                if (response.data) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                setServerStatus(false);
                setServiceUrl("");
            } finally {
                setServerLoadState(false);
            }
        };

        initializeData();

        // ✅ Always start polling if there are in-progress files
        const checkAndStartPolling = async () => {
            const projectCode = sessionStorage.getItem("projectCode");
            if (!projectCode) return;

            try {
                const response = await axios.get(
                    `${TRANSCRIPT_URL}/transcribe/in-progress/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                if (response.data && response.data.data && response.data.data.length > 0) {
                    console.log(`🔄 Found ${response.data.data.length} in-progress files, starting polling`);
                    startPolling();
                }
            } catch (error) {
                console.log("No initial polling needed");
            }
        };

        checkAndStartPolling();

        // ✅ Cleanup on unmount
        return () => {
            stopPolling();
        };
    }, [fetchAllFiles, fetchInProgressTranscriptions, startPolling, stopPolling]);

    // ✅ Add periodic refresh for in-progress files (every 30 seconds)
    useEffect(() => {
        if (inProgressFiles.length === 0) return;

        const refreshInterval = setInterval(() => {
            console.log("🔄 Refreshing in-progress files list...");
            fetchInProgressTranscriptions();
        }, 30000); // Every 30 seconds

        return () => clearInterval(refreshInterval);
    }, [inProgressFiles.length, fetchInProgressTranscriptions]);

    // ✅ Switch to All Files Status when all files complete
    // useEffect(() => {
    //     if (startProcess && inProgressFiles.length > 0) {
    //         const allCompleted = inProgressFiles.every(file => 
    //             file.status === 'success' || file.status === 'error'
    //         );
            
    //         if (allCompleted) {
    //             setStartProcess(false);
    //             setActiveTab(3);
    //             stopPolling();
    //         }
    //     }
    // }, [inProgressFiles, startProcess, stopPolling]);

    // ✅ Switch to All Files Status when all files complete
    useEffect(() => {
        console.log('Checking completion:', inProgressFiles.map(f => ({ name: f.name, status: f.status })));
        
        if (startProcess) {
            // Only switch if we had files and now they're gone (completed)
            if (inProgressFiles.length === 0 && processedFiles.length > 0) {
                console.log('All files completed, switching to All Files Status');
                setStartProcess(false);
                setActiveTab(3);
                stopPolling();
            } else if (inProgressFiles.length > 0) {
                // Check if all are completed
                const allCompleted = inProgressFiles.every(file => 
                    file.status === 'success' || file.status === 'error'
                );
                
                console.log('All completed?', allCompleted);
                
                if (allCompleted) {
                    setStartProcess(false);
                    setActiveTab(3);
                    stopPolling();
                }
            }
        }
    }, [inProgressFiles, startProcess, processedFiles.length, stopPolling]);

    useEffect(() => {
        if (inProgressFiles.length === 0) return;

        const succeeded = inProgressFiles.filter(f => f.status === "success");
        const failed    = inProgressFiles.filter(f => f.status === "error");

        if (succeeded.length === 0 && failed.length === 0) return;

        setProcessedFiles(succeeded);
        setUnProcessedFiles(failed);

        setLogsData(prev => {
            const updated = [...prev];

            [...succeeded, ...failed].forEach(file => {
                const existingIdx = updated.findIndex(l => l.filename === file.name);
                const logEntry = {
                    filename: file.name,
                    status: file.status,
                    status_code: file.status === "success" ? "0" : "1",
                    status_message: file.status === "success"
                        ? "Transcription completed successfully"
                        : (file.response?.error || "Transcription failed"),
                    transcribed_detected_lang: file.response?.detected_lang || null,
                    api_version: null,
                    confidence_score: null,
                    creation_date: file.last_modified || new Date(),
                };
                if (existingIdx >= 0) {
                    updated[existingIdx] = { ...updated[existingIdx], ...logEntry };
                }
            });
            return updated;
        });
    }, [inProgressFiles]);

    // ✅ Start polling when files are submitted
    // useEffect(() => {
    //     if (inProgressFiles.length > 0) {
    //         startPolling();
    //     } else {
    //         stopPolling();
    //     }
    // }, [inProgressFiles.length, startPolling, stopPolling]);

    // ✅ Handle process start
    // const handleStartProcess = async (data) => {
    //     if (processOption === "normal") {
    //         // ✅ Get API key from storage (same as GetIdeas)
    //         let apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
    //         if (!apiKey) {
    //             apiKey = prompt("Please enter your API key:");
    //             if (!apiKey) {
    //                 setMsg("API key is required.");
    //                 setIsSuccess(false);
    //                 openPopup();
    //                 return;
    //             }
    //             sessionStorage.setItem("api_key", apiKey);
    //             localStorage.setItem("api_key", apiKey);
    //         }
    //         setStartProcess(true);
    //         setActiveTab(1);

    //         // ✅ Fetch params from API
    //         let params = {};
    //         try {
    //             const paramsResponse = await axios.get(
    //                 `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                     },
    //                 }
    //             );
    //             const transcriptParams = paramsResponse.data.data.find(p => p.process_code === 'TRANSCRIPT');
    //             params = transcriptParams?.params || {};
    //         } catch (error) {
    //             console.error("Failed to fetch params:", error);
    //         }

    //         const currentLogs = [];
    //         const updatedProcessedFiles = [];
    //         const updatedUnprocessedFiles = [];

    //         const formattedStartDateTime = () => {
    //             const date = new Date();
    //             const formattedDateString = date
    //                 .toLocaleString("en-US", {
    //                     day: "2-digit",
    //                     month: "2-digit",
    //                     year: "numeric",
    //                     hour: "2-digit",
    //                     minute: "2-digit",
    //                     second: "2-digit",
    //                     hour12: false,
    //                 })
    //                 .replace(/\//g, "/")
    //                 .replace(",", " ");
    //             const [month, day, yearAndTime] = formattedDateString.split("/");
    //             return `${day}-${month}-${yearAndTime}`;
    //         };

    //         for (let i = 0; i < data.length; i++) {
    //             let startdt = formattedStartDateTime();
    //             let file = data[i];
                
    //             try {
    //                 if (!file.file_code) {
    //                     throw new Error("File code is missing");
    //                 }

    //                 const payload = {
    //                     project_code: sessionStorage.getItem("projectCode"),
    //                     file_code: file.file_code,
    //                     api_key: apiKey,
    //                     // service: transcriptionSettings.service,
    //                     // keep_original_lang: transcriptionSettings.keep_original_lang,
    //                     // enable_pre_process: transcriptionSettings.enable_pre_process,
    //                     // pii_masking: transcriptionSettings.pii_masking,
    //                     // ...(transcriptionSettings.pii_entities_list.length > 0 && {
    //                     //     pii_entities_list: transcriptionSettings.pii_entities_list
    //                     // })
    //                     service: params.service || 'openai',
    //                     keep_original_lang: params.keep_original_lang || 0,
    //                     enable_pre_process: params.enable_pre_process || 0,
    //                     pii_masking: params.pii_masking || 0,
    //                     ...(params.pii_entities_list && {
    //                         pii_entities_list: params.pii_entities_list
    //                     })
    //                 };

    //                 const response = await axios.post(
    //                     `${TRANSCRIPT_URL}/transcribe/`,
    //                     payload,
    //                     {
    //                         headers: {
    //                             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                             "Content-Type": "application/json"
    //                         },
    //                     }
    //                 );

    //                 // if (response.data.status === "submitted") {
    //                 //     const submittedFile = {
    //                 //         ...file,
    //                 //         status: "submitted",
    //                 //         response: response.data.message,
    //                 //         start_date_time: startdt,
    //                 //         last_modified: "",
    //                 //         transcription_model: transcriptionSettings.service
    //                 //     };
                        
    //                 //     currentLogs.push({
    //                 //         creation_date: new Date(),
    //                 //         filename: file.name,
    //                 //         status: "submitted",
    //                 //         message: response.data.message
    //                 //     });
                        
    //                 //     updatedProcessedFiles.push(submittedFile);
                        
    //                 //     // ✅ Add to in-progress files immediately
    //                 //     setInProgressFiles(prev => [...prev, submittedFile]);
    //                 // } else {
    //                 if (response.data.status === "submitted") {
    //                     const submittedFile = {
    //                         ...file,
    //                         file_code: file.file_code,  // ✅ Make sure file_code is included
    //                         status: "submitted",
    //                         response: {  // ✅ Make it an object, not string
    //                             message: response.data.message,
    //                             submitted_at: new Date().toISOString()
    //                         },
    //                         start_date_time: startdt,
    //                         last_modified: "",  // ✅ Empty string is fine for "in progress"
    //                         transcription_model: params.service || 'openai'
    //                     };
                        
    //                     currentLogs.push({
    //                         creation_date: new Date(),
    //                         filename: file.name,
    //                         status: "submitted",
    //                         message: response.data.message
    //                     });
                        
    //                     updatedProcessedFiles.push(submittedFile);
                        
    //                     // ✅ Add to in-progress files immediately
    //                     setInProgressFiles(prev => [...prev, submittedFile]);
    //                 } else {
    //                     console.error('Unexpected response status:', response.data.status);
    //                     const errordate = new Date();
    //                     currentLogs.push({
    //                         creation_date: errordate,
    //                         filename: file.name,
    //                         status: "error"
    //                     });
    //                     updatedUnprocessedFiles.push(file);
    //                 }
    //             } catch (error) {
    //                 console.error('Transcription Error:', error);
                    
    //                 const errordate = new Date();
    //                 let errorMessage = error.response?.data?.detail || 
    //                                 error.response?.data?.message || 
    //                                 error.message ||
    //                                 "An error occurred during transcription";
                    
    //                 currentLogs.push({
    //                     filename: file.name,
    //                     creation_date: errordate,
    //                     error: errorMessage
    //                 });
                    
    //                 setMsg(errorMessage);
    //                 setIsSuccess(false);
    //                 if (data.length === 1) {
    //                     openPopup();
    //                 }
                    
    //                 updatedUnprocessedFiles.push(file);
    //             }
    //         }

    //         setLogsData(currentLogs);
    //         setProcessedFiles(updatedProcessedFiles);
    //         setUnProcessedFiles(updatedUnprocessedFiles);
    //         // setStartProcess(false);
    //         // setActiveTab(3);
            
    //         // ✅ Refresh available files (remove submitted ones)
    //         await fetchAllFiles();
            
    //         // ✅ Start polling for results
    //         if (updatedProcessedFiles.length > 0) {
    //             startPolling();
    //         }
    //     } else {
    //         // Background process mode
    //         setBackgroundProcess(true);
    //         const fileNames = data.map((file) => file.name);
    //         try {
    //             const response = await axios.post(
    //                 `${TRANSCRIPT_URL}/transcribe/background/${sessionStorage.getItem("projectCode")}`,
    //                 {
    //                     files: fileNames,
    //                     serverState: serverOFF
    //                 },
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                     },
    //                 }
    //             );
    //             if (response) {
    //                 setMsg(response.data.message);
    //                 setServerStatus(response.data.serverStatus);
    //                 setIsSuccess(true);
    //                 openPopup();
    //             }
    //         } catch (error) {
    //             const errorMessage = handleApiError(error);
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             openPopup();
    //         }
    //         setBackgroundProcess(false);
    //         ReloadData();
    //     }
    // };

    const handleStartProcess = async (data) => {
        if (processOption === "normal") {
            setStartProcess(true);
            setActiveTab(1);

            let apiKey = null;
            let params = {};
            
            try {
                // ✅ FIX: Fetch project details instead of params
                const projectResponse = await axios.post(
                    `${PROJECT_URL}/projects/list`,
                    {
                        userInfo: {
                            _id: sessionStorage.getItem("userid"),
                            clientId: sessionStorage.getItem('client'),
                            role: sessionStorage.getItem('role')
                        },
                        payload: {}
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        }
                    }
                );
                
                // ✅ Find the current project
                const currentProject = projectResponse.data.find(
                    p => p.project_code === sessionStorage.getItem("projectCode")
                );
                
                console.log("🔍 Current project:", currentProject);
                
                if (currentProject) {
                    // ✅ Get API key directly from project
                    if (currentProject.azure_enabled && currentProject.azure_param) {
                        // Azure mode: use gpt_key for fallback (transcription)
                        apiKey = currentProject.gpt_key;
                        params = {
                            service: 'azure',
                            azure_key: currentProject.azure_param.azure_key,
                            azure_endpoint: currentProject.azure_param.azure_endpoint
                        };
                    } else {
                        // OpenAI mode
                        apiKey = currentProject.gpt_key;
                        params = {
                            service: 'openai'
                        };
                    }
                    
                    console.log("🔑 Found API key:", apiKey ? "YES ✅" : "NO ❌");
                    console.log("📦 Using service:", params.service);
                } else {
                    console.error("❌ Project not found in list");
                }
                
            } catch (error) {
                console.error("❌ Failed to fetch project:", error);
            }

            const modelProvider = params.service || "openai";

            // ✅ Fallback to session/localStorage (for local development)
            if (!apiKey || apiKey.trim() === "") {
                apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
                console.log("🔄 Using fallback API key:", apiKey ? "YES" : "NO");
            }

            // ✅ Final validation
            if (!apiKey || apiKey.trim() === "") {
                console.error("❌ No API key found anywhere");
                setMsg("API key not configured. Please add an API key in Project Setup.");
                setIsSuccess(false);
                openPopup();
                setStartProcess(false);
                return;
            }

            // ✅ NEW: Check if transcription parameters are configured
            let activeTranscriptionParams = {};
            try {
                const paramsResponse = await axios.get(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                const activeParam = paramsResponse.data.data.find(
                    p => p.process_code === "TRANSCRIPT" && p.status === true
                );

                if (!activeParam || !activeParam.fields || activeParam.fields.length === 0) {
                    setMsg("Transcription parameters are not configured. Please configure parameters in the Params tab before starting transcription.");
                    setIsSuccess(false);
                    openPopup();
                    setStartProcess(false);
                    return;
                }

                if (Array.isArray(activeParam.fields)) {
                    activeParam.fields.forEach(field => {
                        activeTranscriptionParams[field.key] = field.value;
                    });
                }

            } catch (error) {
                console.error("❌ Failed to fetch transcription params", error);
                setMsg("Unable to fetch transcription parameters. Please configure parameters in the Params tab.");
                setIsSuccess(false);
                openPopup();
                setStartProcess(false);
                return;
            }

            console.log("✅ Proceeding with transcription");

            const currentLogs = [];
            const updatedProcessedFiles = [];
            const updatedUnprocessedFiles = [];

            const formattedStartDateTime = () => {
                const date = new Date();
                const formattedDateString = date
                    .toLocaleString("en-US", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                    })
                    .replace(/\//g, "/")
                    .replace(",", " ");
                const [month, day, yearAndTime] = formattedDateString.split("/");
                return `${day}-${month}-${yearAndTime}`;
            };

            // ✅ Fetch ACTIVE transcription params (from Params.js configuration)
            // let activeTranscriptionParams = {};

            try {
                const paramsResponse = await axios.get(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                const activeParam = paramsResponse.data.data.find(
                    p => p.process_code === "TRANSCRIPT" && p.status === true
                );

                if (activeParam && Array.isArray(activeParam.fields)) {
                    activeParam.fields.forEach(field => {
                        activeTranscriptionParams[field.key] = field.value;
                    });
                }

                console.log("✅ Active transcription params:", activeTranscriptionParams);
            } catch (error) {
                console.error("❌ Failed to fetch active transcription params", error);
            }

            const defaultTranscriptionParams = {
                pii_masking: 0,
                enable_pre_process: 0,
                keep_original_lang: 0
            };

            for (let i = 0; i < data.length; i++) {
                let startdt = formattedStartDateTime();
                let file = data[i];
                
                try {
                    if (!file.file_code) {
                        throw new Error("File code is missing");
                    }

                    // const payload = {
                    //     project_code: sessionStorage.getItem("projectCode"),
                    //     file_code: file.file_code,
                    //     api_key: apiKey,
                    //     service: params.service || 'openai',
                    //     keep_original_lang: 0,
                    //     enable_pre_process: 0,
                    //     pii_masking: 0
                    // };
                    // const payload = {
                    //     project_code: sessionStorage.getItem("projectCode"),
                    //     file_code: file.file_code,
                    //     service: "transcription",          // 🔥 pipeline
                    //     // model_provider: params.service,    // openai | azure
                    //     model_provider: modelProvider,      // openai | azure
                    //     api_key: apiKey,
                    //     pii_masking: 0,
                    //     enable_pre_process: 1,
                    //     keep_original_lang: 1,
                    //     ...(params.service === "azure" && {
                    //         azure_key: params.azure_key,
                    //         azure_endpoint: params.azure_endpoint
                    //     })
                    // };

                    const payload = {
                    project_code: sessionStorage.getItem("projectCode"),
                    file_code: file.file_code,
                    service: "transcription",
                    model_provider: modelProvider,
                    api_key: apiKey,

                    // ✅ apply ACTIVE params from Params.js
                    ...defaultTranscriptionParams,
                    ...activeTranscriptionParams,

                    ...(modelProvider === "azure" && {
                        azure_key: params.azure_key,
                        azure_endpoint: params.azure_endpoint
                    })
                };

                    console.log("📤 Sending transcription request:", payload);

                    const response = await axios.post(
                        `${TRANSCRIPT_URL}/transcribe/`,
                        payload,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                                "Content-Type": "application/json"
                            },
                        }
                    );

                    if (response.data.status === "submitted") {
                        const submittedFile = {
                            ...file,
                            file_code: file.file_code,
                            status: "submitted",
                            response: {
                                message: response.data.message,
                                submitted_at: new Date().toISOString()
                            },
                            start_date_time: startdt,
                            last_modified: "",
                            // transcription_model: params.service || 'openai'
                            transcription_model: modelProvider   // "azure" | "openai"
                        };
                        
                        // Add model_provider info to logs for transparency
                        // currentLogs.push({
                        //     creation_date: new Date(),
                        //     filename: file.name,
                        //     status: "submitted",
                        //     message: response.data.message
                        // });
                        currentLogs.push({
                            filename: file.name,
                            status: "submitted",
                            status_code: null,
                            status_message: response.data.message,
                            transcribed_detected_lang: null,
                            api_version: null,
                            confidence_score: null,
                            creation_date: new Date(),
                        });
                        
                        updatedProcessedFiles.push(submittedFile);
                        setInProgressFiles(prev => [...prev, submittedFile]);
                    } else {
                        console.error('Unexpected response status:', response.data.status);
                        const errordate = new Date();
                        const errorMessage = response.data?.message || "Unexpected response from server";
                        // currentLogs.push({
                        //     creation_date: errordate,
                        //     filename: file.name,
                        //     status: "error"
                        // });
                        currentLogs.push({
                            filename: file.name,
                            status: "error",
                            status_code: "1",
                            status_message: errorMessage,
                            transcribed_detected_lang: null,
                            api_version: null,
                            confidence_score: null,
                            creation_date: errordate,
                        });
                        updatedUnprocessedFiles.push(file);
                    }
                } catch (error) {
                    console.error('Transcription Error:', error);
                    
                    const errordate = new Date();
                    let errorMessage = error.response?.data?.detail || 
                                    error.response?.data?.message || 
                                    error.message ||
                                    "An error occurred during transcription";
                    
                    currentLogs.push({
                        filename: file.name,
                        creation_date: errordate,
                        error: errorMessage
                    });
                    
                    setMsg(errorMessage);
                    setIsSuccess(false);
                    if (data.length === 1) {
                        openPopup();
                    }
                    
                    updatedUnprocessedFiles.push(file);
                }
            }

            setLogsData(currentLogs);
            setProcessedFiles(updatedProcessedFiles);
            setUnProcessedFiles(updatedUnprocessedFiles);
            
            await fetchAllFiles();
            
            if (updatedProcessedFiles.length > 0) {
                startPolling();
            }
        } else {
            // Background process mode
            setBackgroundProcess(true);
            const fileNames = data.map((file) => file.name);
            try {
                const response = await axios.post(
                    `${TRANSCRIPT_URL}/transcribe/background/${sessionStorage.getItem("projectCode")}`,
                    {
                        files: fileNames,
                        serverState: serverOFF
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                if (response) {
                    setMsg(response.data.message);
                    setServerStatus(response.data.serverStatus);
                    setIsSuccess(true);
                    openPopup();
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }
            setBackgroundProcess(false);
            ReloadData();
        }
    };


    // ✅ Reload data for both tabs
    const ReloadData = useCallback(async () => {
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        
        await Promise.all([
            fetchAllFiles(),
            fetchInProgressTranscriptions()
        ]);
    }, [fetchAllFiles, fetchInProgressTranscriptions]);

    // ✅ Handle batch change
    const fetchBatchAudioData = async (batch_no) => {
        await fetchAllFiles(batch_no);
    };

    const tabs = [
        {
            id: 1,
            title: "Audio Files",
            content: (
                <AudioFilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    backgroundProcess={backgroundProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={setProcessOption}
                    setServerOFF={setServerOFF}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    transcriptionSettings={transcriptionSettings}
                    setTranscriptionSettings={setTranscriptionSettings}
                />
            ),
        },
        {
            id: 2,
            title: "Transcription Process",
            content: (
                <TranscriptionProcess
                    startProcess={startProcess}
                    selectedFilesToProcess={inProgressFiles}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                <TranscriptionProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={unprocessedFiles}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: (
                <TranscriptionFilewiseStatusLogs 
                    startIndex={fslstartIndex}
                    endIndex={fslendIndex}
                    setStartIndex={setfslStartIndex}
                    setEndIndex={setfslEndIndex}
                    rowSelection={fslrowSelection}
                    setRowSelection={setfslRowSelection}
                />
            ),
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="Transcription Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={true}
                handleBatchChange={fetchBatchAudioData}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </>
    );
}

export default Transcription;